import * as React from "react";
import Box from "@mui/material/Box";
import { Button, Paper, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import CircularProgress from "@mui/material/CircularProgress";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { enGB } from "date-fns/locale";
import moment from "moment-timezone";
import { default as DataGrid } from "../../../components/LocalizedDataGrid.js";
import { GridActionsCellItem } from "@mui/x-data-grid";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import { useTranslation } from "react-i18next";
import { ApiContext } from "../../../App.js";
import { useLocation } from "react-router-dom";

function checkDateValid(object) {
    if (object === null) {
        return false;
    }
    const date = new Date(object);
    return !isNaN(date.valueOf());
}


const Events = (props) => {
	const { events, localTimezone } = props;

	const { t } = useTranslation();

	const columns = [
		{
			field: "timestamp",
			headerName: t("Time"),
			flex: 1,
			minWidth: 80,
			valueFormatter: (params) => {
				return moment.utc(params.value).tz(localTimezone).format("HH:mm");
			},
		},
		{ field: "point_identifier", headerName: t("ID"), flex: 1, minWidth: 80 },
		{
			field: "point_location",
			headerName: t("Location"),
			flex: 1,
			minWidth: 80,
		},
		{ field: "point_system", headerName: t("System"), flex: 1, minWidth: 80 },
		{ field: "point_name", headerName: t("Device"), flex: 1, minWidth: 80 },
		{ field: "value", headerName: t("Update"), flex: 1, minWidth: 80 },
        { field: "trigger", headerName: t("Trigger"), flex: 1, minWidth: 80 },
		{ field: "status", headerName: t("Status"), flex: 1, minWidth: 80 }
	];

	return (
		<DataGrid
			columns={columns}
			rows={events}
			initialState={{
				sorting: {
					sortModel: [{ field: "timestamp", sort: "desc" }],
				},
			}}
			getRowId={(row) => row.url}
		/>
	);
};

export default function EventViewer(props) {
	const { facility, localTimezone } = props;

	const { t } = useTranslation();

	
	const [events, setEvents] = React.useState([]);

	const {eventsApi} = React.useContext(ApiContext)

    const [date, setDate] = React.useState(new Date());


	React.useEffect(() => {
		
		eventsApi.list(
			facility,
			date,
			(data) => setEvents(data),
			() => {
				window.alert(t("Couldn't retrieve latest events."))
				setEvents([]);
			},
			true
		);
	}, [facility, date]);

	

	return (
		<Box
			sx={{
				backgroundColor: (theme) =>
					theme.palette.mode === "light"
						? theme.palette.grey[100]
						: theme.palette.grey[900],
				overflow: "auto"
			}}
		>
			<Container sx={{ mt: 4, mb: 4 }}>
			<Paper sx={{ p: 2 }}>
                <Stack spacing={2}>
                <Stack direction="row" spacing={2}>
                    <Typography
                        component="h2"
                        variant="h6"
                        color="primary"
                        gutterBottom
                    >
                        {t("Latest events")}
                    </Typography>
                    <Box>
                        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enGB}>
                            <DatePicker
                                label={t("Date")}
                                value={date}
                                inputFormat="dd/MM/yyyy"
                                onChange={(newValue) => {
                                    if (checkDateValid(newValue)) {
                                        setDate(newValue);
                                    }
                                }}
                                renderInput={(params) => <TextField fullWidth size="small" {...params} />}
                            />
                        </LocalizationProvider>
                    </Box>
                </Stack>

							<Box height="calc(100vh - 265px)">
								<Events
									events={events}
									localTimezone={localTimezone}
								/>
							</Box>
                </Stack>
                </Paper>
			</Container>
			
		</Box>
	);
}
